/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_New_PreviewInputs */

const cs_ebr_new_preview = /** @type {(inputs: Ebr_New_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový náhled`)
};

const en_ebr_new_preview = /** @type {(inputs: Ebr_New_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New preview`)
};

/**
* | output |
* | --- |
* | "New preview" |
*
* @param {Ebr_New_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_new_preview = /** @type {((inputs?: Ebr_New_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_New_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_new_preview(inputs)
	return cs_ebr_new_preview(inputs)
});